// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 495) return "scripts/body.js";
	if (chunkId === 240) return "scripts/booking.js";
	if (chunkId === 642) return "scripts/availability.js";
	if (chunkId === 117) return "scripts/vehicle.js";
	if (chunkId === 37) return "scripts/vehicledetails.js";
	if (chunkId === 962) return "scripts/home.js";
	if (chunkId === 353) return "scripts/contact.js";
	if (chunkId === 769) return "scripts/identification.js";
	if (chunkId === 162) return "scripts/forgot.js";
	if (chunkId === 356) return "scripts/createaccount.js";
	if (chunkId === 138) return "scripts/profile.js";
	if (chunkId === 201) return "scripts/business.js";
	if (chunkId === 982) return "scripts/businessdetail.js";
	if (chunkId === 243) return "scripts/businessdetal.js";
	if (chunkId === 609) return "scripts/faq.js";
	if (chunkId === 327) return "scripts/quotation.js";
	// return url for filenames based on template
	return undefined;
};